import React, { ChangeEvent, FC } from 'react';
import styled from 'styled-components';
import { Grey2 } from '../../styles/colours';

const StyledSalesOrgCode = styled.span`
  color: ${Grey2};
  margin: 0 0.75rem 0 0;
  white-space: nowrap;
`;
const StyledRegion = styled.span`
  margin: 0 0.5rem;
`;
const StyledCheckbox = styled.input`
  margin-left: auto;
`;
const StyledLabel = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 1rem;
  cursor: pointer;
`;

const StyledListItem = styled.li`
  list-style-type: none;
`;

export const RegionCheckbox: FC<{
  salesOrgs: string[];
  flagComponent: React.FunctionComponent;
  label: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}> = ({ salesOrgs, flagComponent: Flag, label, checked, onChange }) => {
  return (
    <StyledListItem>
      <StyledLabel>
        <Flag />
        <StyledRegion>{label}</StyledRegion>
        <StyledSalesOrgCode>({salesOrgs.join(', ')})</StyledSalesOrgCode>
        <StyledCheckbox
          data-type="select-region-checkbox"
          data-value={label}
          type="checkbox"
          name={label}
          checked={checked}
          onChange={onChange}
        />
      </StyledLabel>
    </StyledListItem>
  );
};

export const SelectAllCheckbox: FC<{
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}> = ({ checked, onChange }) => {
  return (
    <StyledListItem>
      <StyledLabel>
        <span>(Select all)</span>
        <StyledCheckbox
          data-type="select-all-checkbox"
          data-value="select-all"
          type="checkbox"
          name="select-all"
          checked={checked}
          onChange={onChange}
        />
      </StyledLabel>
    </StyledListItem>
  );
};
